// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_dd6","cls2":"CiterightLanding-cls2_ZR4 CiterightLanding-cls1_dd6"};